export default __webpack_public_path__ + "partner_8e60107.png";